import { Tabs } from 'antd';
import './index.scss';

type Group = {
  is_private: boolean;
  is_user_joined: boolean;
  logo: string;
  member_count: number;
  post_count: number;
  title: string;
  uid: string;
  user_has_pending_application: boolean;
};

const GroupDetailLatestList: React.FC<{
  childrenGroups: Group[];
  is_owner: boolean;
  posts: Group[];
  group: any;
}> = (props) => {
  const tabActiveKey =
    window.location.search.split('&')[1]?.split('=')[1] ||
    props.childrenGroups[0]?.uid;
  const tabChange = (e: string) => {
    window.location.href = `/group/groups/${props.group?.uid}?page=1&child_group_uid=${e}`;
  };

  return (
    <div className={`group-right-slider-bar-container`}>
      <Tabs
        onChange={tabChange}
        activeKey={tabActiveKey}
        style={{ marginTop: 2 }}
      >
        {props.childrenGroups.map((it) => {
          return <Tabs.TabPane tab={it.title} key={it.uid}></Tabs.TabPane>;
        })}
      </Tabs>
    </div>
  );
};

export default GroupDetailLatestList;
